export default __webpack_public_path__ + "static/media/relay_block.c87b0cca.png";